module.exports = __webpack_public_path__ + "media/music/drumkit_9-c9059366.mp3";